// AllocationDetailsModal.jsx
import { Button, Modal, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchAllocationDetails } from "../../../assets/api/allocation";
import { formatCurrency } from "../../../assets/helpers";
import { ReactComponent as EditIcon } from "../../../assets/Icons/Editicon.svg";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import EditAllocationModal from "../EditAllocationModal/EditAllocationModal";
import "./AllocationUserDetailModal.scss";
const AllocationDetailsModal = ({ open, onClose, user, portfolio }) => {
  const [editOpen, setEditOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null);
  const [details, setDetails] = useState([])
  const { token } = useSelector(state => state.auth)
  const { format } = useSelector((state) => state.priceFormat);
  const [exportLoading, setExportLoading] = useState(false)


  useEffect(() => {
    const getAllocationDetails = async () => {
      if (!user?.id) {
        return;
      }
      setLoading(true)
      try {
        const res = await fetchAllocationDetails(user?.id, token, false,portfolio);

        if (res?.status === 200) {
          setDetails(res?.data?.data)
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
      }
    };

    getAllocationDetails();
  }, [user, token]);


  const data = []

  const columns = [
    { title: "Customer Name", dataIndex: "customer_name", key: "customer_name", render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Loan No.", dataIndex: "loan_no", key: "loan_no", render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Bucket", dataIndex: "bucket", key: "bucket", render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Amount Overdue", dataIndex: "amount_overdue", key: "amount_overdue", render: (text) => loading ? <Skeleton.Input size="small" active /> : formatCurrency(text, format) || 'NA' },
    { title: "Bank", dataIndex: "agency_name", key: "agency_name", render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    { title: "Product", dataIndex: "product", key: "product", render: (text) => loading ? <Skeleton.Input size="small" active /> : text || 'NA' },
    {
      title: "Action",
      key: "action",
      render: (_, row) => (
        <Button
          className="edit-icon"
          icon={<EditIcon />}
          onClick={() => {
            setSelectedRow(row);
            setEditOpen(true);
          }}
        />
      ),
    },
  ];

  const handleExportFile = async () => {
    if (!user?.id) {
      return;
    }
    setExportLoading(true)
    try {
      const res = await fetchAllocationDetails(user?.id, token, true , portfolio);
      if (res?.status === 200) {
        const downloadUrl = res?.data?.data?.download_url;
        setExportLoading(false)
        if (downloadUrl) {
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', 'allocation_details.csv');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    } catch (error) {
      setExportLoading(true)

    }
  }

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width={1000}
        title={
          <div className="agentDetailModalHeader">
            <p className="headerLabel">Agent Name</p>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", paddingRight: "20px" }}>
              <div className="agentNameWrapper">
                <p>{user?.name}</p>
                <span>( {user?.role} )</span>
              </div>
              <div>
                <Button loading={exportLoading} onClick={handleExportFile} className="normal-btn-container userwise-export">Export</Button>
              </div>
            </div>
          </div>
        }
        centered
        className="allocationDetailsModal"
      >
        <ReusableTable
          columns={columns}
          dataSource={loading ? Array(5).fill(0) : details?.results}
          pageSize={10}
          totalItems={details?.count}
        />
      </Modal>

      <EditAllocationModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        record={selectedRow}
      />
    </>
  );
};

export default AllocationDetailsModal;
